import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/img_connect.svg'


const _withScopeId = n => (_pushScopeId("data-v-0c8767d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "connectPopup",
  class: "popup-vue"
}
const _hoisted_2 = { class: "sub-title" }
const _hoisted_3 = { class: "content mb30" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "popup-img mb20" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "체크"
  })
], -1))
const _hoisted_5 = { class: "code-subject" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, " 에", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = { class: "code-disease" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, " 1개 질환을 추가합니다.", -1))
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, " 외 ", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, "개 질환을 추가합니다.", -1))
const _hoisted_14 = { class: "btn-confirm-wrap" }



export default /*#__PURE__*/_defineComponent({
  __name: 'ConnectPopup',
  props: {
  context: {
    type: String,
    required: false,
  },
  popupTitle: {
    type: String,
    required: true,
  },
  popupDesc: {
    type: String,
    required: false,
  },
  selectedSubject: {
    type: Object,
    required: true,
  },
  checkedDiseases_all: {
    type: Array,
    required: true,
  },
},
  emits: ['onClick_cancel', 'onClick_confirm'],
  setup(__props, { emit }) {

const props = __props;



/**** content -----------------
 *
 * 예외 팝업
 * /
 * /
/**** hook -------------------- */

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(props.popupTitle), 1),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("p", null, [
        _createElementVNode("span", _hoisted_5, _toDisplayString(__props.selectedSubject.code), 1),
        _createElementVNode("span", null, _toDisplayString(__props.selectedSubject.nameKr), 1),
        _hoisted_6,
        _hoisted_7,
        _createElementVNode("span", _hoisted_8, _toDisplayString(__props.checkedDiseases_all[0].code), 1),
        (__props.checkedDiseases_all.length === 1)
          ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
              _createTextVNode(_toDisplayString(__props.checkedDiseases_all[0].nameKr), 1),
              _hoisted_10
            ]))
          : (_openBlock(), _createElementBlock("span", _hoisted_11, [
              _createTextVNode(_toDisplayString(__props.checkedDiseases_all[0].nameKr), 1),
              _hoisted_12,
              _createTextVNode(_toDisplayString(__props.checkedDiseases_all.length - 1), 1),
              _hoisted_13
            ]))
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("button", {
        class: "btn btn-type-1",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onClick_cancel')))
      }, "취소"),
      _createElementVNode("button", {
        class: "btn btn-type-2",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('onClick_confirm')))
      }, "확인")
    ])
  ]))
}
}

})